import { render } from "./hotQuesView.vue?vue&type=template&id=6f07d2c8"
import script from "./hotQuesView.vue?vue&type=script&lang=js"
export * from "./hotQuesView.vue?vue&type=script&lang=js"

import "./hotQuesView.vue?vue&type=style&index=0&id=6f07d2c8&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__